import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../../Redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import MultiRangeSlider from "../../../Components/MultiRangeSlider";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useHistory } from "react-router-dom";

const CancelledArInvoices = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const cancelledArInvoicesData = useSelector(
    (state) => state?.orderInvoicesReducer?.cancelledArInvoicesData
  );
  console.log(cancelledArInvoicesData, "cancelledArInvoicesData");
  const firstDateOfMonth =
    new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + 1;

  const initialData = {
    from_date: moment(firstDateOfMonth).format("yyyy-MM-DD"),
    to_date: moment(new Date()).format("yyyy-MM-DD"),
    // start_time: "12.00 am",
    // end_time: "12.00 pm",
  };
  const [startDate, setStartDate] = useState(moment(firstDateOfMonth).toDate());
  const [endDate, setEndDate] = useState(new Date());
  const [data, setData] = useState(initialData);

  useEffect(() => {
    dispatch(actions?.getCancelledArInvoicesData(initialData));
    return () => {
      dispatch(actions?.savePaymentsData(null));
    };
  }, []);

  function getStatus(status_id) {
    switch (status_id) {
      case 63:
        return <td className="received">Paid</td>;
        break;

      case 64:
        return <td className="pending">Pending</td>;
        break;

      case 65:
        return <td className="reject">Rejected</td>;
        break;

      case 66:
        return <td className="green_tag">Submitted</td>;
        break;

      default:
        return <td className="green_tag">default</td>;
        break;
    }
  }

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div class="row mx-0">
                  {/* <div className="field text-right mt-3 pt-1 px-0">
                    <button
                      onClick={() => history.push("/finance/sales")}
                      class="btn green-btn-revert mx-0"
                      id="addCount"
                      type="button"
                    >
                      Back to Sales
                    </button>
                  </div> */}
                  <div class="shadowclass top_filters orderpayy mb-3">
                    <h4 class="event-alert py-0 my-2">Filters </h4>
                    <div className="row mx-0">
                      <div class="col-lg-4 col-md-6 pl0 px-0 px-sm-3">
                        <div class="calander d-flex align-items-center">
                          <div class="datePicker pading_right">
                            {/* // <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                            //   <input
                            //     name="from_date"
                            //     class=" "
                            //     required="required"
                            //     type="text"
                            //     id=""
                            //     value="2022-05-01"
                            //   />
                            //   <span class="add-on">
                            //     <i class="fa fa-calendar"></i>
                            //   </span>
                            // </div> */}
                            <DatePicker
                              selected={startDate}
                              dateFormat="dd/MM/yyyy"
                              onChange={(date) => {
                                setStartDate(date);
                                setData({
                                  ...data,
                                  from_date: moment(date).format("yyyy-MM-DD"),
                                });
                              }}
                            />
                          </div>
                          <div class="datePicker pading_lect">
                            {/* <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                              <input
                                name="to_date"
                                class=" "
                                required="required"
                                type="text"
                                id=""
                                value="2022-05-13"
                              />
                              <span class="add-on">
                                <i class="fa fa-calendar"></i>
                              </span>
                            </div> */}
                            <DatePicker
                              selected={endDate}
                              dateFormat="dd/MM/yyyy"
                              onChange={(date) => {
                                setEndDate(date);
                                setData({
                                  ...data,
                                  to_date: moment(date).format("yyyy-MM-DD"),
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-2 col-md-6 timing-duration pt-4 pt-sm-0 mt-md-3 mt-0 mt-lg-0 px-sm-2">
                        <MultiRangeSlider
                          min={0}
                          max={1440}
                          timeRange
                          format="12"
                          onChange={({ min, max }) => {
                            console.log(`min = ${min}, max = ${max}`);
                            setData({
                              ...data,
                              start_time: min,
                              end_time: max,
                            });
                          }}
                        />
                      </div>
                      <div class="selecters col-lg-5 col-md-10 pl-md-0 row mx-0 justify-content-between pt-0 pt-lg-0">
                        <div class="select-div col px-1 pl-md-0">
                          <div class="input select">
                            <select
                              name="waste_group"
                              class="csutom_select"
                              id="WasteWasteGroup"
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  status_id: e.target.value,
                                })
                              }
                            >
                              <option value="">Status</option>
                              {cancelledArInvoicesData?.status?.map((el) => (
                                <option value={el?.value}>{el?.label}</option>
                              ))}
                            </select>
                          </div>{" "}
                        </div>
                        {/* <div class="select-div col px-1">
                          <div class="input select">
                            <select
                              name="waste_type"
                              class="csutom_select"
                              id="WasteWasteType"
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  type: e.target.value,
                                })
                              }
                            >
                              <option value="">Type</option>
                              {cancelledArInvoicesData?.type?.map((el) => (
                                <option value={el?.value}>{el?.label}</option>
                              ))}
                            </select>
                          </div>{" "}
                        </div> */}
                        <div class="select-div col px-1">
                          <div class="input select">
                            <select
                              name="supplier"
                              class="csutom_select"
                              id="WasteSupplier"
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  customer_id: e.target.value,
                                })
                              }
                            >
                              <option value="">Customer</option>
                              {cancelledArInvoicesData?.customers?.map((el) => (
                                <option value={el?.value}>{el?.label}</option>
                              ))}
                            </select>
                          </div>{" "}
                        </div>
                      </div>
                      <div class="col-lg-1 col px-0 pt-3 pt-lg-0 align-right">
                        <button
                          onClick={() => {
                            dispatch(actions?.getCancelledArInvoicesData(data));
                          }}
                          class="btn btn_btnblue"
                          type="submit"
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  </div>{" "}
                </div>
              </div>
            </div>
            <div className="accordion" id="accordionPanelsStayOpenExample">
              <div className="accordion-item">
                <h2
                  className="accordion-header"
                  id="panelsStayOpen-headingNine3"
                >
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseNine3"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseNine3"
                  >
                    <div className="col d-flex align-items-center justify-content-between">
                      <h4 className="event-alert p-0 mb-0">
                        Cancelled Invoices List
                      </h4>
                    </div>
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseNine3"
                  className="accordion-collapse collapse show"
                  aria-labelledby="panelsStayOpen-headingNine3"
                >
                  <div className="">
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div class="d-flex justify-content-between align-items-center flex-wrap">
                            <div className="col-md-4 col-12">
                              <div className="search-box mt-0">
                                <form onSubmit={(e) => e.preventDefault()}>
                                  <input type="text" placeholder="Search" />
                                  <input type="submit" />
                                </form>
                              </div>
                            </div>
                            <button
                              class="btn green-btn-revert add-plus"
                              type="button"
                              onclick="location.href='/ar_invoices/add'"
                            >
                              <i class="i-icon"> </i> Add Invoice
                            </button>
                            {/* <div class="col-sm-auto text-small align-right col-12 mt-2 mt-sm-0">
                              <i>Last Upload July 13, 2022 02:23 PM</i>
                            </div> */}
                          </div>
                          <div className="table-responsive general-setting saved_order_ms">
                            <div className="orderList">
                              <table className="checklist-table remove-space ingredTable">
                                <thead>
                                  <tr>
                                    <th>ID</th>
                                    {cancelledArInvoicesData?.isShowLinkedData && (
                                      <th>Account</th>
                                    )}

                                    <th>Customer</th>
                                    <th>Status</th>
                                    <th>Total</th>
                                    <th>Contact</th>
                                    <th>Created</th>
                                    <th>Updated</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {cancelledArInvoicesData?.invoices?.map(
                                    (el, idx) => (
                                      <tr>
                                        <td>{idx + 1}</td>
                                        {cancelledArInvoicesData?.isShowLinkedData && (
                                          <td>{el?.merchant?.account_name}</td>
                                        )}
                                        <td>
                                          <b> {el?.customer?.full_name}</b>
                                          <br />
                                          ID {el?.ar_invoiceid}
                                        </td>
                                        <td>{el?.status?.status}</td>
                                        {/* {getStatus(el?.status_id)} */}
                                        <td>{el?.total_price}</td>
                                        <td>{el?.customer?.contact_email}</td>
                                        <td>
                                          {moment(el?.created).format(
                                            "MMM DD, YYYY"
                                          )}
                                        </td>
                                        <td>
                                          {moment(el?.modified).format(
                                            "MMM DD, YYYY"
                                          )}
                                        </td>
                                        <td>
                                          <a
                                            onClick={() => {
                                              history.push(
                                                "/order/ar-invoices/new-ar-invoices",
                                                {
                                                  id: el?.id,
                                                  pageType: "edit",
                                                }
                                              );
                                            }}
                                            class="circle_icon"
                                          >
                                            <i class="iconSprites edit-icon"></i>
                                          </a>

                                          <a
                                            class="circle_icon red cancel_invoice"
                                            onClick={() => {
                                              dispatch(
                                                actions?.postCancelOutstandingArInvoicesData(
                                                  { id: el?.id }
                                                )
                                              );
                                            }}
                                          >
                                            <i class="iconSprites cancel-icon"></i>
                                          </a>
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default CancelledArInvoices;
